       import React, { FC, MouseEventHandler, PropsWithChildren, useRef, useState } from "react";
import Navigation from "./Navigation";
import Search from "./search/Search";
import HeaderSearch from "./search/HeaderSearch";
import Banner from "./banner/Banner";
import { useLocation } from "react-router-dom";
import Footer from "./Footer";
import Feedback from "./feedback/Feedback";

const disabledAutocompleteRoutes = ["/help"];

interface LayoutProps extends PropsWithChildren {
}

const Layout: FC<LayoutProps> = (props) => {
    const containerRef = useRef<HTMLDivElement>(null);
    
    const [isScrolledToTop, setIsScrolledToTop] = useState(true);
    const [searchValue, setSearchValue] = useState("");
    
    const location = useLocation();

    const handleHomeClicked = () => {
        setSearchValue("");
    }

    const handleScroll: MouseEventHandler<HTMLDivElement> = (event) => {
        setIsScrolledToTop(event.currentTarget.scrollTop === 0);
    }
    
    const isAutocompleteDisabled = disabledAutocompleteRoutes.includes(location.pathname)
    
    return (
        <div id="top" className="container-uhm" ref={containerRef}>
            <div className="col align-center search-bar" style={{ height: '0em', width: '79vw', position: 'fixed', zIndex: '1000' }}>
                <div className="autocomplete-order-row" style={{ height: '0em' }}>
                    <HeaderSearch searchQuery={searchValue} setSearchQuery={setSearchValue} />
                </div>
            </div>
            <div className="container">
                <div id="aliceContentGrid" onScroll={handleScroll}>

                    <div>
                        <Navigation isScrolledToTop={isScrolledToTop}
                            homeClicked={handleHomeClicked} />
                    </div>
                    
                    <div className="content-flexbox">
                        {window.location.pathname == "/" &&
                            <Banner />
                        }

                        {!isAutocompleteDisabled &&
                            <div className="col align-center search-bar">
                                <div className="autocomplete-order-row">
                                    <Search searchQuery={searchValue} setSearchQuery={setSearchValue} />
                                </div>
                            </div>
                        }

                        {props.children}

                        {window.location.pathname == "/" &&
                            <Feedback />
                        }
                        <Footer />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Layout;